import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import ImportDataAdmin, { IImportDataAdminProps, IImportDataAdminDispatchProps } from './ImportDataAdmin'
import { importData, clearImportDataResult } from './store/ImportDataAdminActions'
import { getImportDataUploading, getImportDataResult } from './store/ImportDataAdminSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'

const mapStateToProps = (state: IGlobalState): IImportDataAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  uploading: getImportDataUploading(state),
  result: getImportDataResult(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
})

const mapDispatchToProps: IImportDataAdminDispatchProps = {
  importData,
  clearImportDataResult,
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportDataAdmin)
